import Error from '../model/Error';
import ParentUser from '../dto/ParentUser';
import axios from 'axios';

export default class ParentUsersRepository {
    static findAllByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/kindergartens/' + kindergartenId + '/parent-users')
                .then(response => resolve(response.data.data.map(data => ParentUser.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
